//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import Swiper from 'swiper'
	export default{
		name:'st_swiper',
		props:['swiperShow'],
		data(){
			return{
				timer:null,
				list:[],//历史掉落
				swiper:null,
			}
		},
		created() {
			//this.getBoxOpenRecord()
			//this.settime()
		},
		updated() {
			if(this.swiper == null){
				this.SwiperInit()
			}
		},		
		methods:{
			close(){
				this.$emit('close')
			},
			//历史掉落
			/*getBoxOpenRecord(){
				BoxOpenRecord('20').then(res => {
					this.list = res.data
				})
			},*/
			
			//历史掉落定时器
			/*settime(){
				this.timer = setInterval(() => {
					this.getBoxOpenRecord()
				},10000)
			},*/
			
			SwiperInit() {
				this.swiper = new Swiper('.swiper-container', {
					speed: 4000, //匀速时间
					// 自动轮播
					autoplay: {
						delay: 500
					},
					//开启循环模式
					loop: true,
					// 网格分布
					slidesPerView: 7,
					allowTouchMove: false,//禁止触摸滑动
					on: {
						tap: (e) => {
							if (e.target.className == 'swiper_info') {
								let item = JSON.parse(e.target.attributes.data.value)
								if (item.dataType == 1) {
									this.$router.push({
										path: '/official/open',
										query: {
											id: item.dataId
										}
									})
								}else{
									if (item.dataType == 2) {
										this.station('grade')
									} else if (item.dataType == 5) {
										const division = (str) => {
											return str.split("&&")[1]
										}
										this.station('lucky_open?name='+ division(item.dataName))
									}
								}
							}
						}
					}
				})
			},
			
			//跨站跳转
			station(path){
				if(sessionStorage.getItem('renew')){
					let list = JSON.parse(sessionStorage.getItem('renew'))
					if(list.length > 0){
						this.set_messageData({
							show:true,
							text:'库存中还有新饰品刮刮乐<br/>确定切换风格吗？',
							path:path
						})
					}else{
						this.set_messageData({
							show:true,
							text:'<br/>进入页面将切换至egg风格',
							path:path
						})	
					}
				}else{
					this.set_messageData({
						show:true,
						text:'<br/>进入页面将切换至egg风格',
						path:path
					})
				}
			},
			
			on_enter() {
				this.swiper.autoplay.stop();
			},
			on_leave() {
				this.swiper.autoplay.start();
			}
		},
		watch:{
			swiperShow(v){
				if(v){
					this.SwiperInit()
				}
			}
		}
	}
